import AppSerializer from 'serializers/app';

class ArticleSerializer extends AppSerializer {
	constructor(store, props) {
		super(store, props);
	}

}

export default ArticleSerializer;